{
    "Profile_History.history": "FR: History",
    "Profile_History.go": "FR: Go"
}
